import { jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const ChildIcon = (props)=>/*#__PURE__*/ jsx("svg", _objectSpreadProps(_objectSpread({}, props), {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 5.5C8.69036 5.5 9.25 4.94036 9.25 4.25C9.25 3.55964 8.69036 3 8 3C7.30964 3 6.75 3.55964 6.75 4.25C6.75 4.94036 7.30964 5.5 8 5.5ZM6 8.45767C5.2417 8.58113 4.49288 8.77532 3.76437 9.04023C3.15145 9.26311 2.5 8.81044 2.5 8.15826C2.5 7.76307 2.74723 7.4101 3.11863 7.27505L3.55734 7.11551C6.42719 6.07193 9.57281 6.07193 12.4427 7.11551L12.8814 7.27505C13.2528 7.4101 13.5 7.76307 13.5 8.15826C13.5 8.81044 12.8486 9.26311 12.2356 9.04023C11.5071 8.77532 10.7583 8.58113 10 8.45767V15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15V8.45767Z",
            fill: props.fill
        })
    }));
ChildIcon.defaultProps = {
    width: 16,
    height: 16,
    fill: 'currentColor'
};

export { ChildIcon as default };
//# sourceMappingURL=Child.mjs.map
